module.exports = "/packs/images/homepage/facilities/gym~c85659dc66d6db17ec027847b8786860.jpg";